import { FC, useRef, useState } from 'react'
import { Avatar, Box, Button, Grid } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { PRIMARY_TRANSPARENT_GREEN } from 'utils/customizedTheme'
import { useGET_userContactsQuery } from 'redux/api/userAPI'
import { MAX_PER_PAGE } from 'utils/constants'
import { Email } from '@mui/icons-material'
import BoxTitle from 'components/atoms/BoxTitle'

const Chat: FC = () => {
  const { t } = useTranslation()
  const inputRef = useRef(null);
  const [contact, setContact] = useState(null)

  const {data: users} = useGET_userContactsQuery({page: 1, page_size: MAX_PER_PAGE})

  return (

        <div className='chat'>
          <div className='chat-left'>

              <div style={{ paddingLeft: '20px', paddingBottom: '10px' }}>
                <BoxTitle title={t('dashboard.peer-colaboration')} icon={<Email />} />
              </div>

              <div className='chat-users'>
                  {users?.results?.map(u => <div key={u.id} className='chat-user' onClick={() => setContact(u)}>
                      <div>
                        
                      <Avatar
                          className='avatar'
                          sx={{
                            bgcolor: PRIMARY_TRANSPARENT_GREEN,
                            width: 50,
                            height: 50,
                            marginLeft: '20px',
                            marginRight: '0px',   
                            display: 'inline-block',
                            position: 'relative',
                            lineHeight: '70px',
                            textAlign: 'center'
                          }}
                          variant='circular'
                          src={u.picture}
                        />

                        </div>
                      <div className='chat-name' >
                        {u.full_name}<br/>
                        <i style={{fontSize: '12px'}}>{t(`roles.${u.role}`)}</i><br />

                      </div>
                    </div>)}

              </div>
          </div>
          <div className='chat-right'>

                {contact && <div style={{ display: 'flex', alignItems: 'center', maxWidth: '300px' }}>
                
                 
                    <Avatar
                      className='avatar'
                      sx={{
                        bgcolor: PRIMARY_TRANSPARENT_GREEN,
                        width: 50,
                        height: 50,
                        gap: '10px',  
                        display: 'inline-block',
                        position: 'relative',
                        lineHeight: '70px',
                        textAlign: 'center'
                      }}
                      variant='circular'
                      src={contact.picture}
                    />

                    <div className='chat-name' >
                      {contact.full_name}<br/>
                      <i style={{fontSize: '12px'}}>{t(`roles.${contact.role}`)}</i><br />
                    </div>

                  </div>
                }       

                <textarea ref={inputRef} disabled={!contact}></textarea>

                <div style={{ textAlign: 'right' }}>

                <Button
                    onClick={() => {
                      inputRef.current.value = "";
                    }}
                    size='small'
                    color='primary'
                    variant='contained'
                    sx={{ width: '150px' }}
                    disabled={!contact}
                  >
                    {t('common.send')}
                  </Button>
                </div>
          </div>
        </div>

  )
}
export default Chat